const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: 8,
    boxShadow: "none!important"
  }),
  thead: {
    position: "sticky"
  },
  // Used by both the header table and the body table
  table: {
    width: "100%",
    // Fixed layout makes both tables use the <colgroup> widths exactly,
    // so header and body columns always line up
    tableLayout: "fixed",
    // Material-UI's default cell padding (4px 56px 4px 24px) made the table too wide
    "& th, & td": {
      padding: "4px 8px",
      overflowWrap: "break-word"
    },
    // IP address and Host: long values wrap inside the narrower columns
    "& tbody td:nth-child(2), & tbody td:nth-child(3)": {
      wordBreak: "break-all"
    }
  },
  tableheader_first: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "11pt",
    textAlign: "left"
  },
  tableheader: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "11pt",
    textAlign: "center"
  },
  tableheaderlast: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "11pt",
    textAlign: "center"
  },
  tablecontent: {
    color: "black",
    fontSize: "11pt",
    textAlign: "center"
  },
  tablecontent_first: {
    //fontWeight: "bold",
    color: "black",
    fontSize: "11pt",
    textAlign: "left"
  },
  tablecontentlast: {
    //fontWeight: "bold",
    color: "black",
    fontSize: "12pt"
  },
  failState: {
    color: theme.palette.fail
  },
  passState: {
    color: theme.palette.success
  },
  // Wrapper around the header and body tables
  div_table1: {
    paddingTop: 30
  },
  // Header: does not scroll. The reserved scrollbar gutter keeps it the same
  // width as the body below, so the columns stay aligned
  div_table_head: {
    overflow: "hidden",
    scrollbarGutter: "stable"
  },
  // Body: only this part scrolls, so the scrollbar starts below the header.
  // height 300 is only a fallback; index.jsx sets the real height to fill the window
  div_table2: {
    height: 300,
    overflowY: "auto",
    overflowX: "hidden",
    scrollbarGutter: "stable"
  },
  table_body: {
    maxHeight: 300,
    overflow: "auto"
  },
  defaultText: {
    fontSize: "14px"
  },
  passedText: {
    color: "#4CAF50",
    fontSize: "14px"
  },
  failedText: {
    color: "#FF5252",
    fontSize: "14px"
  },
  totalGrid: {
    borderRight: "0.5px solid #D3D3D3",
    textAlign: "center"
  },
  totalGridLast: {
    textAlign: "center"
  },
  infoHead: {
    display: "flex",
    margin: "0 Auto",
    width: "80px"
  },
  pass: {
    margin: theme.spacing.unit,
    textAlign: "center"
  },
  table2: {
    overflow: "auto",
    height: 380
  },
  infoText: {
    paddingTop: "2px",
    paddingLeft: "3px",
    whiteSpace: "nowrap"
  }
});

export default styles;